import { IconCircleCheckFilled, IconCircleXFilled, IconClockHour8Filled, IconLoader } from "@tabler/icons-react";

export default function MutationStatusIcon({ mutation }) {
  switch (mutation.status) {
    case "pending":
      return <IconLoader color="blue" />;
    case "error":
      return <IconCircleXFilled color="red" />;
    case "success":
      return <IconCircleCheckFilled color="green" />;

    default:
      return <IconClockHour8Filled color="orange" />;
  }
}
